import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import RSVP from 'rsvp';

class AdminUserRoute extends Route {
  @service store;

  /**
   * @inheritDoc
   */
  model(params) {
    return RSVP.hash({
      user: this.store.findRecord('user', params.user_slug, {
          include: 'payout-accounts'
        }
      ),
    });
  }
}

export default AdminUserRoute;
